import { YinzCamInjectModule } from "yinzcam-inject";
import { YinzCamAppServerToken, YinzCamYCAppServer } from "yinzcam-appserver";
import { injectToken, Token, TokenContainerModule } from "inversify-token";
import { Container, injectable } from "inversify";

export const YinzCamYCAppServerManagerToken = new Token<YinzCamYCAppServerManager>(Symbol.for("YinzCamYCAppServerManager"));

export let YinzCamYCAppServerModule: YinzCamInjectModule = new YinzCamInjectModule((container: Container): void => {
  container.load(new TokenContainerModule((bindToken) => {
    bindToken(YinzCamYCAppServerManagerToken).to(YinzCamYCAppServerManager).inSingletonScope();
  }));
});

@injectable()
export class YinzCamYCAppServerManager {
  public constructor (
    @injectToken(YinzCamAppServerToken) private readonly ycServerManager: YinzCamYCAppServer) {
  }

  public test(): string {
    return this.ycServerManager.test();
  }

  public async saveNewGroup(icon: string|number, name: string, participants: string[]): Promise<any> {
    let rsp = await this.ycServerManager.saveNewGroup(icon, name, participants);
    return rsp;
  }

  public async saveNewChat(data:any) : Promise<any> {
    let rsp = await this.ycServerManager.saveNewChat(data);
    return rsp;
  }
}